export default __webpack_public_path__ + "static/media/iconeTresPontinhos.f1ea42e7.svg";